import { render, staticRenderFns } from "./HistoricoDocumentoLicenca.vue?vue&type=template&id=8485dc4a"
import script from "./HistoricoDocumentoLicenca.vue?vue&type=script&lang=js"
export * from "./HistoricoDocumentoLicenca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports